import { MDBBtn, MDBBtnGroup } from "mdb-react-ui-kit";
import { Dispatch, FC, SetStateAction } from "react";
import styles from "../../styles/search/Search.HelpButtons.module.scss";
import generalSvg from "../../utils/svg-icon/general";

const HelpButtons: FC<{
    setShowModal: Dispatch<SetStateAction<boolean>>;
}> = ({ setShowModal }) => {
    const { FileLine, EnvelopeLine, PhoneLine } = generalSvg;

    return (
        <MDBBtnGroup
            vertical
            aria-label="Vertical button group"
            className="position-fixed end-0 top-50 shadow-0 px-3"
            style={{ transform: "translate(0, -50%)" }}
        >
            <MDBBtn
                floating
                className={`${styles.buttonPhone} my-2 shadow-0`}
                onClick={() => setShowModal(true)}
            >
                <PhoneLine />
            </MDBBtn>
            <MDBBtn
                floating
                className={`${styles.buttonEnvelop} my-2 shadow-0`}
                onClick={() => setShowModal(true)}
            >
                <EnvelopeLine />
            </MDBBtn>
            <MDBBtn
                floating
                className={`${styles.buttonFile} my-2 shadow-0`}
                onClick={() => setShowModal(true)}
            >
                <FileLine />
            </MDBBtn>
        </MDBBtnGroup>
    );
};

export default HelpButtons;
